import { render, staticRenderFns } from "./VeeAssessmentAutocomplete.vue?vue&type=template&id=297a9fd8&scoped=true&"
import script from "./VeeAssessmentAutocomplete.vue?vue&type=script&lang=js&"
export * from "./VeeAssessmentAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./VeeAssessmentAutocomplete.vue?vue&type=style&index=0&id=297a9fd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297a9fd8",
  null
  
)

export default component.exports